<template>
    
    <div class='loader mt-3 mb-3 gray tc'>
      <ico icon='spinner' spin  :size="size+'x'"/>
    </div>

</template>

<script>
export default {
    props:{
      size:{
        default:'1'
      }
    }
}
</script>

<style>

</style>

